export default __webpack_public_path__ + "static/media/manual-loading-icon.444782f3.svg";